/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b9c7af1f0c5c8401116abb40f8b88930>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "Support".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing help support.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const SupportIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.127 2.873a7.25 7.25 0 0 1 0 10.253m0-10.253a7.25 7.25 0 0 0-10.254 0m10.253 0-2.828 2.829m2.829 7.425a7.25 7.25 0 0 1-10.254 0m10.253 0-2.828-2.829m-7.425 2.829a7.25 7.25 0 0 1 0-10.254m0 10.253 2.829-2.828M2.873 2.873l2.829 2.829m4.596 0a3.25 3.25 0 0 1 0 4.596m0-4.596a3.25 3.25 0 0 0-4.596 0m4.596 4.596a3.25 3.25 0 0 1-4.596 0m0 0a3.25 3.25 0 0 1 0-4.596"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
SupportIcon.displayName = 'SupportIcon';
var _default = exports.default = SupportIcon;